export default "__VITE_ASSET__CmdZVY7C__"